import { render } from "./MyFavorites.vue?vue&type=template&id=49501c05&scoped=true&ts=true"
import script from "./MyFavorites.vue?vue&type=script&lang=ts"
export * from "./MyFavorites.vue?vue&type=script&lang=ts"

import "./MyFavorites.vue?vue&type=style&index=0&id=49501c05&lang=less&scoped=true"
import "./MyFavorites.vue?vue&type=style&index=1&id=49501c05&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49501c05"]])

export default __exports__